export const WX_LOGIN_QR = 'WEI_XIN' // 微信扫码
export const DD_LOGIN_QR = 'DING_DING' // 钉钉扫码

export const ACCOUNT_PASSWORD = 'accountPassword' // 账号密码登录
export const SMS_CODE = 'smsCode' // 短信验证码登录
export const SECOND_AUTH = 'secondAuth' // 二次验证
export const QR_LOGIN = 'qrLogin' // 扫码登录

export const LOGIN_SUCCESS_BIND_QR = 'loginSuccessBindQr' // 登录成功后绑定二维码
